/* ============ Algolia Search — Tracking by Snapshot (GTM) ============ */
(function () {
  if (window.__algFilterSnapBound) return;
  window.__algFilterSnapBound = true;

  const pushOnce = (() => {
    const buffers = new Map();
    return function(eventName, part){
      const now = Date.now();
      const buf = buffers.get(eventName) || {
        payload: { event: eventName, page_type: window.__pageType || detectPageType() },
        timer: null,
        t0: now
      };
      Object.assign(buf.payload, part);
      clearTimeout(buf.timer);
      buf.timer = setTimeout(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(buf.payload);
        buffers.delete(eventName);
      }, 50);
      console.log('[dataLayer push]', buf.payload);
      buffers.set(eventName, buf);
    };
  })();

  function dbg(){ if (location.search.includes('debug=1')) console.log.apply(console, arguments); }
  function sendDL(part){ pushOnce('filter_click', part); }

  function normVal(v){
    if (!v) return '';
    try { return decodeURIComponent(v).replace(/\s+/g, ' ').trim(); }
    catch { return String(v).replace(/%20/g, ' ').replace(/\s+/g, ' ').trim(); }
  }

  function snapshotChips(){
    const items = document.querySelectorAll('.ais-current-refined-values--item');
    const out = [];
    items.forEach(it => {
      const cat = it.querySelector('.ais-current-refined-values--label')?.textContent?.trim() || 'Filter';
      const link = it.querySelector('.ais-current-refined-values--link');
      let raw = link?.getAttribute('data-label') || (link?.textContent.split(':')[1] || '').trim() || '';
      const val = normVal(raw);
      if (cat && val) out.push({cat, val});
    });
    return out;
  }

  function diff(prev, curr){
    const toKey = o => o.cat + '|' + o.val;
    const prevSet = new Set(prev.map(toKey));
    const currSet = new Set(curr.map(toKey));
    return {
      added:  curr.filter(o => !prevSet.has(toKey(o))),
      removed: prev.filter(o => !currSet.has(toKey(o)))
    };
  }

  let prevSnap = snapshotChips();

  // ---- NEW: skip pushes when user clicks "Clear all" ----
  let skipNextClearAll = false;
  document.addEventListener('click', function(e){
    if (e.target.closest('.ais-ClearRefinements-button')) {
      skipNextClearAll = true; // the next onRender is from clear-all → ignore it
    }
  }, true);

  // Fire after each Algolia render
  document.addEventListener('algolia.instantSearch.onRender', function(){
    const currSnap = snapshotChips();

    // If the re-render was triggered by "Clear all", skip sending any events
    if (skipNextClearAll) {
      skipNextClearAll = false;
      prevSnap = currSnap; // resync baseline
      dbg('[skip] clear all');
      return;
    }

    const { added, removed } = diff(prevSnap, currSnap);

    added.forEach(({cat, val})   => sendDL({ filter_category: cat, filter_value: val }));
    removed.forEach(({cat, val}) => sendDL({ filter_category: cat, filter_value: val }));

    prevSnap = currSnap;
  });

  // Track search term (optional, separate event)
  document.addEventListener('submit', function(e){
    const f = e.target;
    if (!f || !f.matches('.ais-SearchBox-form')) return;
    const q = f.querySelector('.ais-SearchBox-input')?.value?.trim() || '';
    if (q) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'search_query', page_type: 'search', search_term: q });
      dbg('[search_query]', q);
    }
  }, true);

  (function trackInitialQ(){
    const q = new URLSearchParams(location.search).get('q');
    if (q) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'search_query', page_type: 'search', search_term: q });
      dbg('[search_query initial]', q);
    }
  })();

  dbg('[algolia-snapshot] armed');
})();
